class GiftWrap extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.onCartPage) {
      this.sections = window.BAO.sectionRenderer.cartSections
    }
  }

  setupListeners () {
    this.handleChange = this.handleChange.bind(this)
    this.handleApply = this.handleApply.bind(this)
    this.handleRadio = this.handleRadio.bind(this)

    this.listeners.add(this.els.textarea.element, 'input', this.handleChange)
    this.listeners.add(this.els.apply.element, 'click', this.handleApply)

    this.els.radio.elements.forEach((radioEl) => {
      this.listeners.add(radioEl, 'click', this.handleRadio)
    })
  }

  handleChange () {
    const count = this.els.textarea.element.value.length
    this.els.count.element.innerHTML = count
  }

  async handleApply () {
    const giftMessage = this.els.textarea.element.value

    if (this.onCartPage) {
      const giftwrappingChoice = this.els.radio.elements.find(
        (el) => el.checked,
      )

      this.cart.loading = true

      const cartObj = await BAO.Cart.getCart()
      const currentProperties = cartObj.items.find(
        (item) => item.key === this.getAttribute('data-key'),
      ).properties
      const currentQuantity = cartObj.items.find(
        (item) => item.key === this.getAttribute('data-key'),
      ).quantity

      if (giftwrappingChoice) {
        currentProperties[window.theme.properties.giftWrapping] =
          giftwrappingChoice?.value
      }

      if (giftMessage) {
        currentProperties[window.theme.properties.giftMessage] = giftMessage
      } else {
        delete currentProperties[window.theme.properties.giftMessage]
      }

      const giftWrapVariantId = giftwrappingChoice?.dataset.productVariantId
      if (giftWrapVariantId) {
        await window.BAO.Cart.cartAdd({
          items: [
            {
              quantity: 1,
              id: giftwrappingChoice.dataset.productVariantId,
              properties: {
                _giftwrap_parent_product: this.getAttribute('data-product-id'),
              },
            },
          ],
        })
      }

      const state = await window.BAO.Cart.updateItemProperties(
        this.getAttribute('data-key'),
        currentQuantity,
        currentProperties,
        { sections: this.mappedSections },
      )

      this.cart.loading = false

      if ('sections' in state) this.renderSections(state.sections)
    } else {
      this.externalEls.giftmessage.elements.forEach((giftmessageEl) => {
        if (giftmessageEl.dataset.formId === this.formId) {
          giftmessageEl.value = giftMessage
          if (giftMessage === '') {
            giftmessageEl.setAttribute('disabled', '')
          } else {
            giftmessageEl.removeAttribute('disabled')
          }
        }
      })

      this.externalEls.messagestatus.elements.forEach((messagestatusEl) => {
        if (messagestatusEl.dataset.formId === this.formId) {
          messagestatusEl.innerText = messagestatusEl.dataset.add
        } else {
          messagestatusEl.innerText = messagestatusEl.dataset.edit
        }
      })
    }
  }

  handleRadio (event) {
    const radioEl = event.target.closest(this.els?.radio?.selector)

    this.els?.radio?.elements.forEach((tempEl) => {
      tempEl.checked = tempEl === radioEl
    })

    if (!this.onCartPage) {
      const giftwrappingChoice = this.els.radio.elements.find(
        (el) => el.checked,
      )

      if (giftwrappingChoice) {
        this.externalEls.giftwrapping.elements.forEach((giftwrappingEl) => {
          if (giftwrappingEl.dataset.formId === this.formId) {
            giftwrappingEl.value = giftwrappingChoice?.value
          }
        })

        this.externalEls.triggerlabel.elements.forEach((triggerlabelEl) => {
          if (triggerlabelEl.dataset.formId === this.formId) {
            triggerlabelEl.innerText = giftwrappingChoice?.value
            triggerlabelEl.classList.remove('prd-Form_VariantText-light')
          }
        })
      }
    }
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }

  get cart () {
    return this.closest('cart-item')
  }

  get onCartPage () {
    return this.cart != null
  }

  get formId () {
    return this.dataset.formId
  }
}

if (!customElements.get('gift-wrap')) {
  customElements.define('gift-wrap', GiftWrap)
}
